import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig'; // Adjust the import based on your project structure
import { collection, addDoc, updateDoc, doc, getDoc } from 'firebase/firestore';
import { TextField, Button, Card, CardContent, CardActions, Typography } from '@mui/material';

const HospitalInfo = ({ hospitalId, onClose }) => {
    const [hospitalData, setHospitalData] = useState({
        name: '',
        address: '',
        phone: '',
        doorCode: '',
        miemssID: '',
        bikurCholim: false,
    });

    useEffect(() => {
        if (hospitalId) {
            const fetchHospitalData = async () => {
                const docRef = doc(db, 'hvac', 'GenericData', 'HospitalData', hospitalId);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setHospitalData(docSnap.data());
                } else {
                    console.log('No such document!');
                }
            };
            fetchHospitalData();
        }
    }, [hospitalId]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setHospitalData({
            ...hospitalData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (hospitalId) {
            // Update existing hospital
            const docRef = doc(db, 'hvac', 'GenericData', 'HospitalData', hospitalId);
            await updateDoc(docRef, hospitalData);
            alert('Hospital updated successfully!');
        } else {
            // Add new hospital
            await addDoc(collection(db, 'hvac', 'GenericData', 'HospitalData'), hospitalData);
            alert('Hospital added successfully!');
        }
        setHospitalData({
            name: '',
            address: '',
            phone: '',
            doorCode: '',
            miemssID: '',
            bikurCholim: false,
        });
    };

    const handleClose = () => {
        if (onClose) onClose(); // Call onClose if it's defined
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h5">{hospitalId ? 'Edit Hospital' : 'Add Hospital'}</Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Name"
                        name="name"
                        value={hospitalData.name}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Address"
                        name="address"
                        value={hospitalData.address}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Phone"
                        name="phone"
                        value={hospitalData.phone}
                        onChange={handleChange}
                        fullWidth
                    />
                    <TextField
                        label="Door Code"
                        name="doorCode"
                        value={hospitalData.doorCode}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                    <TextField
                        label="MIEMSS ID"
                        name="miemssID"
                        value={hospitalData.miemssID}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                    <div>
                        <label>
                            <input
                                type="checkbox"
                                name="bikurCholim"
                                checked={hospitalData.bikurCholim}
                                onChange={handleChange}
                            />
                            Bikur Cholim
                        </label>
                    </div>
                    <CardActions>
                        <Button type="submit" color="primary">
                            {hospitalId ? 'Update Hospital' : 'Add Hospital'}
                        </Button>
                        <Button onClick={handleClose} color="secondary">Cancel</Button>
                    </CardActions>
                </form>
            </CardContent>
        </Card>
    );
};

export default HospitalInfo;
